module.exports = __webpack_public_path__ + "img/search.af9f705.svg";